import { render, staticRenderFns } from "./eventConf.vue?vue&type=template&id=01c0488e"
import script from "./eventConf.vue?vue&type=script&lang=js"
export * from "./eventConf.vue?vue&type=script&lang=js"
import style0 from "./eventConf.vue?vue&type=style&index=0&id=01c0488e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports